import React, { Component } from 'react';
import { ReactComponent as BiddingIcon } from 'Icons/bidding.svg';
import Select from 'react-select';
import Input from 'Components/Input/index';
import { TAT_UNITS } from 'Constants/commonConstants';
import Moment from 'moment';

class BiddingAndPayments extends Component {
    constructor(props) {
        super(props);
        const biddingDetails = props.biddingDetails;
        this.viewMode = props.viewMode;
        this.viewType = props.viewType;
        this.biddingDetails = biddingDetails;
        this.state = {
            biddingDetails,
            isMissingUOM: false,
            isConfirmation: false
        }
    }

    onChange = (e)=> {
        if(this.viewMode) {
            return;
        }
        
        const { rfq } = this.props;
        const name = e.target.name;
        const value = e.target.value;
        if(value < 0) {
            return;
        }
        this.biddingDetails['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
        this.setState({
            biddingDetails: this.biddingDetails
        })
        this.props.onChange()
    }

    onSelect = (value, name)=> {
        if(this.viewMode) {
            return;
        }
        this.biddingDetails['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
        this.setState({
            biddingDetails: this.biddingDetails
        })
        this.props.onChange()

    }

    render() {
        const {
            lppDetails,
            businessVolumes,
            isError
        } = this.props;
        const { biddingDetails } = this.state;

        return (
            <div className='vehicleDetails mt-20'>
                <div className='ph-20 pb-10'>
                    <div className='pt-20 flex mb-20'>
                            <BiddingIcon />
                            <div className='ml-10 header'>Bidding and Payments</div>
                    </div>
                    <div className='flex'>
                        <div className='col-2 mr-15'>
                            <div className='rfqlabel'>LPP :
                                <div className="rfqlabel fBold">{lppDetails && <span>{lppDetails.lpp}</span>} {' '}
                                {lppDetails && <span>{(lppDetails.pricing_basis || '').replace(' per ', '/')}</span>} </div>
                                <div className="rfqlabel fSemibold"><span>LPP Date: </span>{lppDetails && <span className="theme-color">{lppDetails.lpp_date_time && Moment(lppDetails.lpp_date_time).format('DD MMM YYYY') || '-'}</span>}</div>
                                <div className="rfqlabel fSemibold"><span>Vehicle Type: </span>{lppDetails && <span className="theme-color">{lppDetails.lpp_vehicle_type || '-'}</span>}</div>
                            </div>
                        </div>  
                        <div  className='col-2 ml-15'>
                            <div className='rfqlabel'>Celling Price</div>
                            <Input  
                                type="number" 
                                onChange={this.onChange} 
                                value={biddingDetails.qbr} 
                                name="qbr" 
                                onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()} 
                            />
                        </div>
                    </div>
                    <div className='flex mt-20'>
                        <div className='col-2 mr-15'>
                            <div className='rfqlabel'>TAT</div>
                            <div className='flex'>
                                <Input type="number" className="wt-100 mr-10" placeholder={0} onChange={this.onChange} value={biddingDetails.tatValue} name="tatValue"/>
                                <Select 
                                    className="col-1"
                                    options={[...TAT_UNITS]} 
                                    value={TAT_UNITS.find(tatUnit=>{return biddingDetails.tatUnit === tatUnit.value})}
                                    getOptionLabel={option => option.name}
                                    onChange={(option) => this.onSelect(option, 'tatUnit')}
                                />
                            </div>
                        </div>
                        <div className='col-2 ml-15'>
                            <div className='rfqlabel'>Bussiness Volume</div>
                            <div className='flex'>
                                <Input type="number" className="wt-100 mr-10" placeholder={0} onChange={this.onChange} value={biddingDetails.businessVolumeValue} name="businessVolumeValue"/>
                                <Select 
                                    className="col-1"
                                    options={businessVolumes} 
                                    value={businessVolumes.find(businessVolumeUnit=>{return biddingDetails.businessVolumeUnit === businessVolumeUnit.value})}
                                    getOptionLabel={option => option.name}
                                    onChange={(option) => this.onSelect(option, 'businessVolumeUnit')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='flex mt-20'>
                        <div className='col-2 mr-15'>
                            <div className='rfqlabel'>Budget</div>
                            <Input type="number"  onChange={this.onChange} value={biddingDetails.budget} name="budget" />
                        </div>
                        <div className='col-2 ml-15'>
                            <div className='rfqlabel'>Diesel Price <sup className='error-color fs-14'>*</sup></div>
                            <Input type="number" onChange={this.onChange} value={biddingDetails.diesel_price ? biddingDetails.diesel_price : 0} name="dieselprice"/>
                            {isError && !(biddingDetails.diesel_price) && <span className="error-color fs-14 fSemibold op-7 ml-5">Please Enter the Field</span>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default BiddingAndPayments;